import { FC } from "react";
import withPage from "../../components/Page";
import Hero from "../../components/Hero";
import { globalContent } from "../../config/content";
import styles from "./NotFound.module.scss";

const NotFound: FC = () => {
  return (
    <div className={styles.notFoundPage}>
      <Hero
        eyebrow="Page Not Found"
        heading="This page could not be found."
        copy="The page you are looking for might have been removed, had its name changed, or is temporarily unavailable. Return to the homepage or view the demo to explore Pulse."
        backgroundImage={require("../../assets/images/hero/corporate-office-suite.webp")}
        button={{
          text: "Return to Homepage",
          to: "/",
          variant: "secondary",
        }}
        secondaryButton={{
          text: "View the Demo",
          to: globalContent.demoUrl,
          variant: "outlineLight",
        }}
      />
    </div>
  );
};

export default withPage(NotFound)({
  meta: globalContent.seo.notFound,
});
